
import { GoogleGenAI } from "@google/genai";
import { Language, Message } from "../types";
import { SYSTEM_PROMPT } from "../constants";

export class GeminiService {
  /**
   * Use gemini-3-flash-preview for general text tasks as per instructions.
   */
  private modelName = 'gemini-3-flash-preview';

  async generateResponse(userInput: string, history: Message[], language: Language, userName: string): Promise<string> {
    // Correctly initialize with process.env.API_KEY directly as per guidelines.
    const ai = new GoogleGenAI({ apiKey: process.env.API_KEY });
    
    try {
      const contents = history.map(msg => ({
        role: msg.role === 'user' ? 'user' : 'model',
        parts: [{ text: msg.text }]
      }));

      contents.push({
        role: 'user',
        parts: [{ text: userInput }]
      });

      const response = await ai.models.generateContent({
        model: this.modelName,
        contents: contents as any,
        config: {
          systemInstruction: SYSTEM_PROMPT(language, userName),
          temperature: 0.7,
        },
      });

      return response.text || '';
    } catch (error: any) {
      console.error("[GeminiService] Error details:", error);
      
      let errorMessage = "API Request Failed";
      const errStr = String(error).toUpperCase();
      
      if (errStr.includes("403") || errStr.includes("PERMISSION_DENIED") || errStr.includes("REFERER")) {
        errorMessage = "API Key Restriction: Access from this domain might be blocked. Check your Google Cloud Console API Key settings.";
      } else if (error.message) {
        errorMessage = error.message;
      }
      
      throw new Error(errorMessage);
    }
  }
}

export const geminiService = new GeminiService();
